import { jsPDF } from 'jspdf';

const formatDate = (value) => {
  if (!value) return '';
  const raw = String(value);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[3]}/${match[2]}/${match[1]}`;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return raw;
  const day = String(parsed.getDate()).padStart(2, '0');
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const year = parsed.getFullYear();
  return `${day}/${month}/${year}`;
};

const buildEndereco = (c = {}) => {
  const parts = [
    c.RuaLocalizacao,
    c.NumeroLocalizacao ? `n. ${c.NumeroLocalizacao}` : '',
    c.BairroLocalizacao,
    c.CidadeLocalizacao,
    c.EstadoLocalizacao,
    c.CEPLocalizacao ? `CEP ${c.CEPLocalizacao}` : '',
  ].filter(Boolean);
  if (c.ComplementoLocalizacao) parts.push(c.ComplementoLocalizacao);
  return parts.join(', ');
};

const buildFileName = (base) => {
  const safe = String(base || 'curriculo').replace(/[^\w]+/g, '_');
  return `${safe}.pdf`;
};

export const generateCurriculoPdf = (candidato = {}) => {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 40;
  let y = 90;

  const nomeCompleto = [candidato?.Nome, candidato?.Sobrenome]
    .filter(Boolean)
    .join(' ')
    .trim() || 'Candidato';
  const titulo = candidato?.TituloVaga || 'Curriculo';

  doc.setFillColor(18, 111, 199);
  doc.rect(0, 0, pageWidth, 80, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.text(nomeCompleto, margin, 40);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  doc.text(titulo, margin, 62);

  const addSectionTitle = (title) => {
    if (y + 28 > pageHeight - margin) {
      doc.addPage();
      y = margin;
    }
    doc.setTextColor(18, 111, 199);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(title, margin, y);
    doc.setDrawColor(18, 111, 199);
    doc.setLineWidth(1);
    doc.line(margin, y + 4, pageWidth - margin, y + 4);
    y += 18;
    doc.setTextColor(51, 51, 51);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
  };

  const addLine = (label, value) => {
    if (!value) return;
    if (y + 16 > pageHeight - margin) {
      doc.addPage();
      y = margin;
    }
    doc.setFont('helvetica', 'bold');
    doc.text(`${label}:`, margin, y);
    const labelWidth = doc.getTextWidth(`${label}: `);
    doc.setFont('helvetica', 'normal');
    const text = doc.splitTextToSize(String(value), pageWidth - margin * 2 - labelWidth);
    doc.text(text, margin + labelWidth + 6, y);
    y += 14 + (text.length - 1) * 12;
  };

  addSectionTitle('Contato');
  addLine('E-mail', candidato?.Email);
  addLine('Telefone', candidato?.NumeroTelefone);
  addLine('Cidade/UF', [candidato?.CidadeLocalizacao, candidato?.EstadoLocalizacao].filter(Boolean).join(' / '));

  addSectionTitle('Dados pessoais');
  addLine('CPF', candidato?.CPF);
  addLine('PIS', candidato?.PIS);
  addLine('Escolaridade', candidato?.Escolaridade);
  addLine('Endereco', buildEndereco(candidato));

  addSectionTitle('CNH');
  addLine('Numero', candidato?.NumeroCNH);
  addLine('Categoria', candidato?.CategoriaCNH);
  addLine('Validade', formatDate(candidato?.ValidadeCNH));

  addSectionTitle('Experiencias profissionais');
  const experiencias = Array.isArray(candidato?.experienciasProfissionais)
    ? candidato.experienciasProfissionais
    : [];

  if (experiencias.length === 0) {
    addLine('Info', 'Nenhuma experiencia informada.');
  } else {
    experiencias.forEach((exp) => {
      const periodo = (() => {
        const inicio = formatDate(exp?.DataInicio);
        const fim = exp?.EmpregoAtual ? 'Atual' : formatDate(exp?.DataFinal);
        if (!inicio && !fim) return '';
        return `${inicio || 'Inicio nao informado'} - ${fim || 'Fim nao informado'}`;
      })();

      if (y + 40 > pageHeight - margin) {
        doc.addPage();
        y = margin;
      }

      doc.setFont('helvetica', 'bold');
      doc.text(exp?.Cargo || 'Cargo nao informado', margin, y);
      doc.setFont('helvetica', 'normal');
      y += 14;
      if (exp?.NomeEmpresa) {
        doc.text(exp.NomeEmpresa, margin, y);
        y += 12;
      }
      if (periodo) {
        doc.setTextColor(85, 85, 85);
        doc.text(periodo, margin, y);
        doc.setTextColor(51, 51, 51);
        y += 12;
      }
      if (exp?.Detalhes) {
        const detalhes = doc.splitTextToSize(String(exp.Detalhes), pageWidth - margin * 2);
        doc.text(detalhes, margin, y);
        y += 12 + (detalhes.length - 1) * 12;
      }
      y += 6;
    });
  }

  const fileName = buildFileName(`curriculo_${nomeCompleto}`);
  doc.save(fileName);
  return fileName;
};
